import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import NouvelleFichesStock from "./nouvellesFichesStock";
import EnCours from "./enCours";
import Suivis from "./suivis.jsx";
import Valide from "./valide.jsx";
import Abandonnee from "./abandonnee.jsx";
import Toutes from "./toutes.jsx";
import Stockage from "./ficheStockage.jsx";
import HistoriqueMailsStock from "./historiqueMailsStock"; 

export default function FicheListe() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showHistorique, setShowHistorique] = useState(false);

  const tabPanels = [
    "Nouvelles",
    "En cours",
    "Suivis",
    "Validé",
    "Stockage",
    "Abandonnées",
    "Toutes",
  ];

  useEffect(() => {
    const storedIndex = localStorage.getItem("activeTabIndexFiche");
    if (storedIndex !== null) {
      setActiveIndex(parseInt(storedIndex, 10));
    }
  }, []);


  useEffect(() => {
    if (showHistorique && activeIndex < tabPanels.length) {
      setShowHistorique(false);
    }
  }, [activeIndex, showHistorique]);

  const handleTabChange = (e) => {
    setActiveIndex(e.index);
    localStorage.setItem("activeTabIndexFiche", e.index);
  };

  const handleHistoriqueClick = () => {
    setShowHistorique(true);
    setActiveIndex(tabPanels.length);
  };

  return (
    <div className="relative">
      <div className="w-full flex justify-content-end mb-2">
        <Button
          label="Historique des mails"
          icon="pi pi-envelope"
          onClick={handleHistoriqueClick}
          className="p-button-outlined"
        />
      </div>

      <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
        <TabPanel header="Nouvelles"><NouvelleFichesStock /></TabPanel>
        <TabPanel header="En cours"><EnCours /></TabPanel>
        <TabPanel header="Suivis"><Suivis /></TabPanel>
        <TabPanel header="Validé"><Valide /></TabPanel>
        <TabPanel header="Stockage"><Stockage /></TabPanel>
        <TabPanel header="Abandonnées"><Abandonnee /></TabPanel>
        <TabPanel header="Toutes"><Toutes /></TabPanel>

        {showHistorique && (
          <TabPanel header="Historique des mails de stockage">
           <HistoriqueMailsStock />
          </TabPanel>
        )}
      </TabView>
    </div>
  );
}
